import type { IOption } from "~/types/option";

import { SpreadFilterEnum } from "./types";

export const labelBySpreadFilterEnum: Record<SpreadFilterEnum, string> = {
  [SpreadFilterEnum.All]: "All",
  [SpreadFilterEnum.One]: "1\u00A2",
  [SpreadFilterEnum.Three]: "3\u00A2",
  [SpreadFilterEnum.Seven]: "7\u00A2",
  [SpreadFilterEnum.Ten]: "10\u00A2",
  [SpreadFilterEnum.Custom]: "Custom",
};

export const spreadDecimalByFilterEnum: Partial<
  Record<SpreadFilterEnum, number>
> = {
  [SpreadFilterEnum.One]: 0.01,
  [SpreadFilterEnum.Three]: 0.03,
  [SpreadFilterEnum.Seven]: 0.07,
  [SpreadFilterEnum.Ten]: 0.1,
};

export const SPREAD_FILTER_OPTIONS: IOption<SpreadFilterEnum>[] = [
  SpreadFilterEnum.All,
  SpreadFilterEnum.One,
  SpreadFilterEnum.Three,
  SpreadFilterEnum.Seven,
  SpreadFilterEnum.Ten,
  SpreadFilterEnum.Custom,
].map((value) => ({
  value,
  label: labelBySpreadFilterEnum[value],
}));

export const PRESET_SPREAD_OPTIONS = SPREAD_FILTER_OPTIONS.filter(
  (option) => option.value !== SpreadFilterEnum.Custom
);

export const CUSTOM_SPREAD_OPTION = SPREAD_FILTER_OPTIONS.find(
  (option) => option.value === SpreadFilterEnum.Custom
)!;

export const SPREAD_TOOLTIP_TEXT =
  "Spread is the difference between the best ask and best bid price. Available only for active events. Smaller spreads generally indicate higher liquidity.";

export const MAX_CUSTOM_SPREAD_CENTS = 100;
